import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

const ArrowSVG = () => (
  <svg
    className="carousel-arrow"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#424242"
      fillRule="evenodd"
      d="M17.197 12.5H5.464C5.208 12.5 5 12.276 5 12s.208-.5.464-.5h11.733l-4.031-3.628a.5.5 0 0 1 .668-.744l5 4.5a.5.5 0 0 1 0 .744l-5 4.5a.5.5 0 1 1-.668-.744l4.031-3.628z"
    />
  </svg>
);

export const CustomArrowButton = ({ onClick, style, className }) => (
  <button className={className} style={style} onClick={onClick}>
    <ArrowSVG />
  </button>
);

export const slickBreakpoints = {
  mobile: 768 - 1,
  tablet: 1024 - 1,
  desktop: 1440 - 1,
  desktopLarge: 2560 - 1,
  desktopMax: 3000,
};

const defaultSliderOptions = {
  accessibility: true,
  arrows: true,
  centerMode: false,
  centerPadding: '50px',
  dots: true,
  rows: 1,
  nextArrow: <CustomArrowButton type="next" />,
  prevArrow: <CustomArrowButton type="prev" />,
  responsive: null,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 6000,
  speed: 1200,
  useTransform: true,
  cssEase: 'ease-in-out',
  className: '',
};

const Carousel = ({ options, children }) => {
  return (
    <Slider {...defaultSliderOptions} {...options}>
      {children}
    </Slider>
  );
};

Carousel.propTypes = {
  options: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element),
};
export default Carousel;
